import { Location, LocationDataStore } from '@skinsoft/entity';
import { locationSelectors } from '@skinsoft/entity/src/location';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
    props: ['id'],
    template: require('./location-name.html'),
})
export class LocationName extends ReactiveVue {
    get value() {
        return locationSelectors.translatedTitle(this.location, this.$i18n.locale);
    }

    public id: string;
    public $locationDataStore: LocationDataStore;
    public location: Location = null as any;

    private subscribeToLocation() {
        this.subscribeTo(
            this.$locationDataStore.fetchOne(this.id),
            location => {
                this.location = location;
            },
            'location',
        );
    }

    @Watch('id', { immediate: true })
    private onIdChange(id: string) {
        this.unsubscribeFrom('location');
        if (id) {
            this.subscribeToLocation();
        }
    }
}
